import PropTypes from 'prop-types';
import React from 'react';
import { reduxForm } from 'redux-form';
import {
  defineMessages,
  injectIntl,
  intlShape,
  FormattedMessage,
} from 'react-intl';

import Message from 'brastrap/common/message/Message';
import { apiLogin } from 'shared/actions/auth';

import LoginForm from 'brastrap/transactional/login-form/LoginForm';

const messages = defineMessages({
  identifiedOnly: {
    id: 'auth.identified-only',
    defaultMessage: 'Please log in again.',
  },
});

const Login = props => {
  let message = null;
  if (props.isIdentified) {
    message = (
      <Message modifiers={['inform', 'banner']} dismissable={false}>
        <FormattedMessage {...messages.identifiedOnly} />
      </Message>
    );
  }

  return (
    <LoginForm
      handleSubmit={props.handleSubmit}
      fields={props.fields}
      message={message}
      isFetching={props.isFetching}
    />
  );
};

Login.propTypes = {
  identifiedEmail: PropTypes.string,
  isIdentified: PropTypes.bool,
  isFetching: PropTypes.bool,
  intl: intlShape,
  message: PropTypes.object,
  handleSubmit: PropTypes.func.isRequired,
  fields: PropTypes.object,
  location: PropTypes.object,
};

export default injectIntl(
  reduxForm(
    {
      form: 'loginForm',
      fields: ['email', 'password'],
      onSubmit: (credentials, dispatch, props) => {
        const nextPath = props.location.state
          ? props.location.state.nextPathname
          : `${props.basePath}account/personal`;
        dispatch(apiLogin(credentials, nextPath));
      },
    },
    state => ({
      initialValues: {
        email:
          state.auth.isIdentified && state.auth.user
            ? state.auth.user.email
            : '',
      },
      isIdentified: state.auth.isIdentified,
      isFetching: state.auth.isFetching,
      message: state.auth.message,
      basePath: state.app.config.basePath,
      location: state.app.routing,
    })
  )(Login)
);

export const UnwrappedLogin = Login;
